import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import CardExpand from '@/views/components/CardExpand.vue';
import SeletorOpcoesImpressão from '@/views/components/SeletorOpcoesImpressão.vue';
import { IJurisprudencia } from '../../types';
import IconPaginaSimplificada from '@/views/components/icons/IconPaginaSimplificada.vue';
import IconPaginaDetalhada from '@/views/components/icons/IconPaginaDetalhada.vue';
import IconTextoNorma from '@/views/components/icons/IconTextoNorma.vue';
import JurisprudenciaSelecionadaService from '@/views/jurisprudencia-selecionada/service';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';

interface IProps {
  jurisprudencia?: IJurisprudencia;
  isSelecionado: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardResultado',
  props: {
    jurisprudencia: null,
    isSelecionado: { type: Boolean }
  },
  emits: ['toggle-check'],
  setup(__props: any) {

const props = __props as {
  jurisprudencia?: IJurisprudencia;
  isSelecionado: boolean;
};





const expandido = ref(true);

const showDetalhes = ref(false);

const itensImpressao = [
  {
    text: 'Acórdãos',
    value: 'A',
    icone: IconTextoNorma,
  },
  {
    text: 'Simplificado',
    value: 'S',
    icone: IconPaginaSimplificada,
  },
  {
    text: 'Detalhado',
    value: 'D',
    icone: IconPaginaDetalhada,
  },
];

const title = computed(
  () =>
    `${props.jurisprudencia?.deClasse || ''} ${
      props.jurisprudencia?.nuProcOrigem || ''
    }`
);

const highlightedDesc = computed(
  () => props.jurisprudencia?.highlightedDesc || ''
);

const prolatores = computed(() => {
  if (
    !props.jurisprudencia?.prolatores ||
    !props.jurisprudencia.prolatores.length
  ) {
    return '';
  }

  if (props.jurisprudencia.prolatores.length > 1) {
    return props.jurisprudencia.prolatores
      .map((prolator) => prolator.nmProlator)
      .join(', ');
  }

  return props.jurisprudencia.prolatores[0].nmProlator;
});

watch(
  () => props.jurisprudencia,
  async (newValue, oldValue) => {
    if (newValue != oldValue) {
      expandido.value = true;
      showDetalhes.value = false;
    }
  },
  { deep: true }
);

const download = (tipoImpressao: 'A' | 'S' | 'D') => {
  const cdAcordao = props.jurisprudencia?.cdAcordao;
  const cdJurisprudencia = props.jurisprudencia?.cdJurisprudencia;
  const flSegredoJustica = props.jurisprudencia?.flSegredoJustica;

  if (tipoImpressao === 'A' && flSegredoJustica === 'N' && cdAcordao) {
    JurisprudenciaSelecionadaService.downloadAcordao(cdAcordao);
  }

  if (tipoImpressao === 'S' && cdJurisprudencia) {
    JurisprudenciaSelecionadaService.downloadSimplificado([cdJurisprudencia]);
  }

  if (tipoImpressao === 'D' && cdJurisprudencia) {
    JurisprudenciaSelecionadaService.downloadDetalhado([cdJurisprudencia]);
  }
};

return { __sfc: true,props, expandido, showDetalhes, itensImpressao, title, highlightedDesc, prolatores, download, CardExpand, SeletorOpcoesImpressão, mdiChevronDown, mdiChevronUp }
}

})